'use client';

import React from 'react';

import WidgetHeader from 'src/components/Profiles/shared/widgets/WidgetHeader';
import { Card } from 'src/components/PulseUI';
import WidgetLoading from 'src/components/Profiles/shared/widgets/shared/WidgetLoading';
import WidgetEmpty from 'src/components/Profiles/shared/widgets/shared/WidgetEmpty';
import { formatCurrency } from 'src/utils/formatCurrency/formatCurrency';
import useExpectedOpportunity from './useExpectedOpportunity';

const ExpectedOpportunity: React.FC = () => {
  const { expectedOpportunity, isLoading, periodLabel, yearLabel } =
    useExpectedOpportunity();

  return (
    <Card
      className="p-5 flex flex-col gap-2 bg-white h-full"
      data-testid="expected-opportunity"
      role="region"
      aria-label="Expected Opportunity"
    >
      <WidgetHeader
        fallbackTitle="Expected Opportunity"
        showDateRange={false}
      />
      <div className="flex-1 min-h-0 overflow-y-auto">
        {isLoading ? (
          <WidgetLoading data-testid="expected-opportunity-loading" className="flex items-center justify-center py-8" />
        ) : expectedOpportunity == null ? (
          <WidgetEmpty data-testid="expected-opportunity-empty" variant="full" />
        ) : (
          <div
            className="flex flex-col gap-1"
            data-testid="expected-opportunity-content"
          >
            <span
              className="text-xs text-neutral-400"
              data-testid="expected-opportunity-subtitle"
            >
              Based on {yearLabel} volume, {periodLabel}
            </span>
            <span
              className="text-3xl font-bold text-sky-900 tabular-nums mt-2"
              data-testid="expected-opportunity-amount"
            >
              {formatCurrency(expectedOpportunity)}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default ExpectedOpportunity;
